import {Box, Divider, Typography} from "@mui/material";

export default function PageHeader(props: {
    title: string;
    action?: JSX.Element;
    helpTag?: string;
    color?: string;
}) {
    return (
        <Box sx={{ mb: 2 }}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "end",
                    pb: 1.5,
                    minHeight: 60,
                }}
            >
                <Typography color={props.color || "text.primary"} fontSize="medium">
                    {props.title}
                </Typography>

                <Box flexGrow={1} />

                {props.action}
            </Box>

            <Divider />
        </Box>
    );
}
